/** * 弹窗演示 * 徐杰 * 2019-4-22 **/
<template>
  <div>
    <X-Layout>
      <div class="realtimepage">
        <!-- 内容区域 -->
        <Row :gutter="20">
          <i-col span="6">
            <div class="leftbox">
              <div class="linehr"></div>
              <Spin v-if="treeLoading" fix>
                <Icon type="ios-loading" size="18" class="demo-spin-icon-load" />
                <div>菜单加载中...</div>
              </Spin>
              <Input style="width: 200px" v-model="seachCName" class="tabdiv" placeholder="搜索企业">
                <span slot="append" @click="getTreeInfo"><Icon type="ios-search-outline" /></span>
              </Input>

              <div style="overflow: hidden">
                <el-tree
                  ref="treeBox"
                  node-key="keyID"
                  :data="treeData"
                  :default-expanded-keys="expandedKeys"
                  :props="defaultProps"
                  :highlight-current="true"
                  :render-content="renderContent"
                  @node-click="handleNodeClick"
                />
              </div>
            </div>
          </i-col>
          <i-col span="18" class="rightBigBox">
            <div class="company_text">{{ companyName || '' }}</div>

            <!-- 日曲图 -->
            <div class="boxinterval">
              <div class="daybrokeline">
                <div class="brokeleft">
                  <div class="broketext">日曲图</div>
                  <div class="optionlist">
                    <RadioGroup v-model="btnFlag" @on-change="checkBtn">
                      <template v-for="(item, index) in monitorList">
                        <Radio :label="item.codeId" :key="index">{{ item.cnName }}</Radio>
                      </template>
                    </RadioGroup>
                  </div>
                </div>
              </div>
              <div class="daybrokentable" ref="dayBrokenTable"></div>
            </div>

            <!-- 历史工况 -->
            <div class="boxinterval">
              <div class="historybox">
                <div class="historyleft">
                  <div class="historytext">列表</div>
                </div>
              </div>

              <!-- 数据表格 -->
              <i-table width="100%" stripe :columns="columns2" :data="yyTableList" :loading="tbLoading" />
            </div>
          </i-col>
        </Row>
      </div>
    </X-Layout>
  </div>
</template>

<script>
import 'element-ui/lib/theme-chalk/index.css';
import tableLine from '../../echartsTable/table-line.vue';
import { formatDateTime1, createTree, customContent, getTableTitle } from '@/common/common.js';
import echarts from 'echarts';
import { parseTime } from '@/utils/date.js';
export default {
  components: {
    tableLine,
  },
  data() {
    return {
      formatime: '',
      dayCurveList: [], //
      echart: '',
      outletName: '', // 排口名字
      columns2: [], // 表格数据
      monitorList: [], // 所有检测项
      unit: '', // 检测项的单位
      monitName: '', // 检测项的名字
      yyTableList: [], // 表格数据
      companyName: '',
      labelTime: formatDateTime1(new Date()), // 获取当前时间
      labelList: [], // 图表数据
      btnFlag: '', // 默认被选中的按钮
      checkId: '',
      activeFlag: 'name1', // 被选中的选项
      dataList: [], // 实时
      defaultProps: {
        // 设置树菜单的接受格式
        children: 'childrens',
        label: 'title',
      },
      expandedKeys: [], // 指定树菜单展开key
      treeData: [], // 树菜单数据
      treeLoading: false, // 树菜单加载动画
      dataInfoLoading: false, // 信息加载动画
      gkNowData: {
        // 实时工况数据
        time: '离线', // 监测时间
        pro: '', // 生产线状态
        rkyl: '', // 入口压力
        fjdl: '', // 风机电流
        ckyl: '', // 出口压力
        url: [], // 现场照片
        ckwd: '', // 出口温度
        fs: '', // 风速
      },
      comids: '',
      gkSite_id: '', // 排口id
      listindex: '', // 删除数组中的第几个数据
      seachCName: '', // 搜索企业名
      tbLoading: false, // 数据表的加载动画开关
      total: 0, // 总数
      page: 1, // 当前第一页
      row: 10, // 每页多少数据
    };
  },
  destroyed() {
    window.onresize = '';
  },

  mounted() {
    this.comids = this.$route.params.id ? this.$route.params.id : null; // 有传入公司ID
    this.getTreeInfo(); // 执行初始化树菜单

    window.onresize = () => {
      this.echart.resize();
    };
  },

  methods: {
    // 初始化图表
    initEcharts(dataList, dataTime) {
      this.echart = echarts.init(this.$refs.dayBrokenTable);
      this.echart.clear();
      this.echart.setOption({
        tooltip: {
          trigger: 'axis',
          backgroundColor: '#fff',
          borderColor: '#FFFFFF',
          extraCssText: 'box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.16);',
          padding: 10,
          textStyle: {
            // 提示框浮层的文本样式。
            color: '#233C52',
            fontSize: 12,
          },
          formatter: res => {
            let opt = '';
            let status = 0;
            let icon = '';
            for (let i = 0; i < res.length; i++) {
              const element = res[i];
              if (i == 0) {
                opt += `<div>${this.formatime} ${element.axisValue}</div>`;
                status = this.dayCurveList[element.dataIndex].status;
                if (status == 1) {
                  icon = '<i class="icon iconfont icon-down" style="font-size: 10px"/>';
                } else if (status == 2) {
                  icon = '<i class="icon iconfont icon-up-copy" style="font-size: 10px" />';
                }
              }

              opt += `<div><span>${element.seriesName}</span>：<span style="color:${
                status == 0 ? element.color : '#E72D14'
              }" >${element.value}${this.unit}${icon}</span></div>`;
            }
            return opt;
          },
        },
        color: ['#3DD598', '#FA8B15', '#0062FF', '#FF5B5B'],
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true,
        },
        toolbox: {
          feature: {
            saveAsImage: {},
          },
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: dataTime,
        },
        yAxis: {
          type: 'value',
        },
        series: [
          {
            name: this.monitName,
            type: 'line',
            itemStyle: {
              normal: {
                lineStyle: {
                  width: 3, //设置线条粗细
                },
              },
            },
            smooth: true,
            data: dataList,
          },
        ],
      });
      setTimeout(() => {
        this.echart.resize();
      }, 100);
    },
    // 按钮被选中事件
    checkBtn() {
      for (let i = 0; i < this.monitorList.length; i++) {
        const element = this.monitorList[i];
        if (element.codeId == this.btnFlag) {
          console.log('element', element);
          this.unit = element.unit;
          this.monitName = element.cnName;
          break;
        }
      }
      // 获取当前检测项的数据
      this.getYYNowInfo();
    },
    /**
     * 树菜单使用的render 使用自定义格式 返回对应的样式
     */
    renderContent: function (h, { node, data, store }) {
      // 判断树菜单层级
      switch (
        data.level // 判断树菜单层级
      ) {
        case 1: // 第1层 街道显示数量 报警变色
          return customContent(data, node, h);

        case 2: // 第2层 公司需要显示数量 报警变色
          return customContent(data, node, h);

        case 3: // 第3层 排口不需要显示数量 报警变色
          return customContent(data, node, h);
      }
    },
    /**
     * 渲染树菜单 根据树菜单要求处理传入得到list数据
     * 获取第一层
     */
    handleTreeList(list) {
      // 遍历树形菜单 后台数据
      const res = createTree(list, this.comids);
      this.expandedKeys = res.keyGkId; // 被展开的key
      this.treeData = res.list; // 整理好的树形列表
      this.gkSite_id = res.selGkId; // 记录id
      this.companyName = res.comName + ' - ' + res.gkName; // 公司名
      this.$nextTick(() => {
        // 设置选中高亮
        this.$refs.treeBox.setCurrentKey(res.keyGkId[1]);
      });

      this.getYYNowInfo(); // 2.执行【实时数据】
      this.getYYHistoryInfo(); // 【历史数据】渲染表格
    },
    /**
     * 初始化树菜单数据
     */
    getTreeInfo() {
      const api = this.ApiUrl + 'ycData/findAllYc';
      const data = {
        param: this.seachCName,
      };
      this.treeLoading = true; // 开启加载动画
      this.dataInfoLoading = true; // 把信息页加载动画也开启
      // 请求接口
      this.$http
        .post(api, data, {
          emulateJSON: 'application/x-www-form-urlencoded',
        })
        .then(
          res => {
            if (res.data.extend.news === 0) {
              var list = res.data.extend.pageInfo;
              this.handleTreeList(list); // 1.渲染树菜单
            }

            this.treeLoading = false; // 开启加载动画
          },
          res => {
            this.treeLoading = false; // 开启加载动画
          },
        );
    },
    /**
     * 树菜单单击事件
     */
    handleNodeClick(data) {
      if (data.gkSite_id == this.gkSite_id) {
        return;
      }
      this.gkSite_id = data.gkSite_id;
      this.outletName = data.gkSite_name;

      // 如果是第3层 就触发 表格事件
      if (data.level === 3) {
        this.yyTableList = []; // 清空数据表
        this.dataList = []; // 清空实时数据
        this.btnFlag = ''; // 清空检测项
        this.monitorList = []; // 清空检测项列表
        this.labelList = []; // 清空图表数据
        this.companyName = data.parentName;
        this.gkSite_id = data.gkSite_id; // 设置选中排口Id
        this.page = 1; // 初始化 设置第一页
        this.total = 0; // 初始化总条数
        this.getYYNowInfo(); // 执行【实时数据】
        this.getYYHistoryInfo(); // 【历史数据】渲染表格
      }
    },
    /**
     * 得到油烟 【实时数据】
     */
    getYYNowInfo() {
      const apis = 'ycData/getTodayHourDataChart';
      this.data = {
        gkSiteId: this.gkSite_id, // 排口id
        codeId: this.btnFlag || 0, // 检测项的id
      };

      this.dataInfoLoading = true; // 开启加载动画
      // 开启请求
      this.$http.post(this.ApiUrl + apis, this.data).then(
        res => {
          if (res.data.extend.news == 0) {
            // 图表数据
            const dataList = [];
            let dataTime = [];
            const list = res.data.extend.chartData;
            this.dayCurveList = list;
            for (let i = 0; i < list.length; i++) {
              // 获取当天的实时数据

              dataList.push(list[i].value);
              dataTime.push(list[i].hour * 1 < 10 ? '0' + list[i].hour : list[i].hour);
            }
            // 将数据赋给图表数据
            this.labelList = dataList;
            // 获取监控项
            if (res.data.extend.codeMapList && res.data.extend.codeMapList.length > 0) {
              this.monitorList = res.data.extend.codeMapList;
              // 被选中的监控项如果没有值就将第一个值赋给他
              if (!this.btnFlag) {
                this.btnFlag = res.data.extend.codeMapList[0].codeId;
                this.unit = res.data.extend.codeMapList[0].unit;
                this.monitName = res.data.extend.codeMapList[0].cnName;
              }
            }
            this.formatime = parseTime(this.tableTime || new Date(), '{y}-{m}-{d}');
            this.initEcharts(dataList, dataTime);
            // 初始化图表
            // 数据列表，表头，检测项，单位，是否离线
            // this.$refs.lineChart.initChart(
            //   dataList,
            //   this.monitName,
            //   this.unit,
            //   res.data.extend.hasOffline,
            //   this.labelTime,
            // );
          }

          this.dataInfoLoading = false; // 关闭加载动画
        },
        res => {
          this.dataInfoLoading = false; // 关闭加载动画
        },
      );
    },

    // 被选中项的事件(图表 name1 表格 name2)
    checkedTab() {
      if (this.activeFlag == 'name1' && this.labelList.length <= 0) {
        this.getYYNowInfo();
      } else if (this.activeFlag == 'name2' && this.yyTableList.length <= 0) {
        this.getYYHistoryInfo();
      }
    },
    /**
     * 实时数据表格
     */
    getYYHistoryInfo() {
      const apis = 'ycData/getTodayHourDataTable';
      this.data = {
        gkSiteId: this.gkSite_id,
      };

      this.tbLoading = true; // 开启加载动画
      // 开启请求
      this.$http.post(this.ApiUrl + apis, this.data).then(
        res => {
          if (res.data.extend.news === 0) {
            // 表数据
            this.yyTableList = res.data.extend.tableData;

            // 表头数据
            if (res.data.extend.codeMapList.length > 0) {
              this.columns2 = getTableTitle(res.data.extend.codeMapList, this.page, this.row, 1, this.labelTime);
            }

            this.total = res.data.extend.total; // 设置总页数
          } else {
            this.total = 0;
          }
          this.tbLoading = false; // 关闭加载动画
        },
        res => {
          this.total = 0;
          this.tbLoading = false; // 关闭加载动画
        },
      );
    },

    // 切换显示的页数
    onPageSize(e) {
      this.row = e;
      this.getYYHistoryInfo(); // 执行油烟【历史数据】数据表
    },
    // 切换下一页
    onNextPage(e) {
      this.page = e;
      this.getYYHistoryInfo(); // 执行油烟【历史数据】数据表
    },
    // 刷新页面
    reload() {
      location.reload();
    },
  },
};
</script>
<style lang="scss">
.realtimepage {
  .ivu-table td,
  .ivu-table th {
    border-bottom: none;
  }
}
</style>
<style scoped lang="scss">
.realtimepage {
  .leftbox {
    background: #fff;
    overflow: hidden;
    position: relative;
    padding: 20px 15px;

    .linehr {
      height: 5px;
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      background-color: #0062ff;
    }
  }
  .company_text {
    font-size: 16px;
    font-weight: bold;
    line-height: 20px;
    color: #333333;
    position: relative;
    padding-left: 14px;
    margin-bottom: 15px;
  }
  .company_text::before {
    content: '';
    position: absolute;
    top: 50%;
    left: 0;
    transform: translateY(-50%);
    background: #0062ff;
    width: 4px;
    height: 14px;
  }

  .boxinterval {
    background: #fff;
    padding: 15px;
    margin-bottom: 15px;
  }
  .daybrokeline {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 5px;
    .brokeleft {
      display: flex;
      align-items: center;
      .broketext {
        font-size: 16px;
        font-weight: bold;
        color: #233c52;
        position: relative;
        padding-left: 9px;
        margin-right: 36px;
      }
      .broketext::before {
        position: absolute;
        content: '';
        top: 50%;
        left: 0;
        transform: translateY(-50%);
        width: 4px;
        height: 16px;
        background-color: #0062ff;
      }
      .optionlist {
        margin-left: 20px;
      }
    }
  }
  .daybrokentable {
    height: 250px;
    width: 100%;
    position: relative;
  }
  .historybox {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 10px;
    .historyleft {
      display: flex;
      align-items: center;
      .historytext {
        padding-left: 9px;
        position: relative;
        font-size: 16px;
        font-weight: bold;
        color: #233c52;
        margin-right: 20px;
      }
      .historytext::before {
        content: '';
        width: 4px;
        height: 16px;
        background: #0062ff;
        position: absolute;
        top: 50%;
        left: 0;
        transform: translateY(-50%);
      }
    }
    .historyright {
      i {
        margin-right: 5px;
        font-size: 14px;
      }
    }
  }
}
.ivu-table {
  font-size: 14px;
}

.topbtn {
  display: flex;
}

.topbtn > div {
  margin-right: 20px;
}

.divday {
  margin-top: 2px;
}

.divday > button {
  margin-right: 5px;
}

.timebox {
  margin-top: 2px;
}

.changbox > button {
  border-radius: 0;
  padding-left: 30px;
  padding-right: 30px;
}

.yyNow {
  padding: 18px 24px;
  background-color: #fafafa;
  border: 1px solid #eaeefb;
  margin-bottom: 25px;
  border-radius: 4px;
  text-align: center;
}

.yyNow i {
  font-size: 36px;
}

.yyNow .ctime {
  width: 100px;
  min-height: 26px;
  color: #fff;
  padding: 2px;
  border-radius: 4px;
  margin: 12px auto;
  font-size: 14px;
}

.yyDiv {
  display: flex;
  overflow-x: auto;
  overflow-y: hidden;
}

.yyDiv .yyz {
  width: 100%;
  min-width: 900px;
  flex-shrink: 0;
}

.imgbox {
  padding-top: 2.5rem;
  width: 100%;
  height: auto;
  display: flex;
  flex-wrap: wrap;
}

.imgbox img {
  width: 6.25rem;
  height: 6.25rem;
}

.vertical-center-modal {
  display: flex;
  align-items: center;
  justify-content: center;
}

.icon {
  font-size: 1.5rem;
}

.refresh {
  float: right;
  margin-right: 1.25rem;
}

.optdiv {
  display: flex;
  padding: 0.625rem 0;
  justify-content: space-between;
}

.tabdiv {
  margin-bottom: 20px;
  width: 80%;
}

.comname {
  padding: 10px 0;
  display: block;
  color: #cccccc;
}

.boxStatus {
  width: 100px;
  min-height: 26px;
  color: #fff;
  padding: 2px;
  border-radius: 4px;
  margin: 12px auto;
  font-size: 14px;
  line-height: 26px;
}

.normal {
  background-color: #19be6b;
}

.exceed {
  background-color: #ed4014;
}

.btnList {
  display: flex;
  flex-wrap: nowrap;
  letter-spacing: 2px;
}

.btnList > div {
  margin-left: 5px;
}

.rightBox {
  position: relative;
  min-width: 900px;
}
</style>
